import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export const Dropdown = ({ children, render, open, onClose, parentRef }) => {
    const [isOpen, setOpen] = useState(open);
    const node = useRef(null);

    const close = useCallback(() => {
        setOpen(false);
        onClose();
    }, [onClose]);

    const handleClickOutside = useCallback((e) => {
        if ((parentRef || node).current.contains(e.target)) {
            return;
        }
        close();
    }, [close, parentRef]);

    useEffect(() => {
        setOpen(open);
        if (open) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open, handleClickOutside]);

    return (
        <div ref={node}>
            {isOpen && ((render && render(close)) || children)}
        </div>
    );
};

Dropdown.propTypes = {
    children: PropTypes.node,
    render: PropTypes.func,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    parentRef: PropTypes.object,
};

Dropdown.defaultProps = {
    children: React.Fragment,
    render: () => {},
    open: false,
    onClose: () => {},
    parentRef: null,
};
